
































import Media from '@/types/Media.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    props: {
        media: {
            type: Object as PropType<Media>,
            required: true
        }
    },
    methods: {
        close(): void {
            //  This just tells our dialog to close
            this.$emit('submit')
        },
        downloadImg(): void {
            this.$store.dispatch('mediaDownload', this.media)
        },
        outClick(e: MouseEvent): void {
            //  Cast our target to an HTML element
            const target = e.target as HTMLElement

            //  Check if this target has an id AND if it matches mediaPreview
            const outerClick = target.id && target.id === 'mediaPreview'

            //  If this is an outer click, then close our dialog
            if (outerClick) this.$emit('submit')
        }
    }
})
